import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function SelectedCaidReducer(state = initialState.selectedCaids, action: any) {
  switch (action.type) {
    case types.SAVE_SELECTED_CAIDS_SUCCESS:
      return action.selectedCaids;
    default:
      return state;
  }
}
